ui-offcanvas-panel {
  .slide {
    background-color: $ui-grey-minus-3;
  }

  .ui-container {
    height: 100%;
    padding-top: 4rem;
  }

  ui-realestate-search-filters {
    display: block;
    padding: 1rem 0;
  }
}
